import useFieldGroup from 'src/hooks/form/useFieldGroup';
import React from 'react';
// import { UsableElemProps, UsableFieldProps } from 'src/components/common/form/FieldNodeSingle';
import { isValidArray } from 'src/Library/Helper';
import useRefs from '../useRefs';
import useField, { useFieldProps } from './useField';
import { FieldHookProps } from 'src/components/common/form/form.types';

// export type UsableFieldProps = {
//   field: ReturnType<typeof useField>;
//   children: React.ReactElement;
// };

// export type UsableElemProps = Omit<useFieldProps<any>, 'key'> & { formKey: string };

const useMultiField = <RefType = any>({
  defaultNode,
  requestRerender,
  defaultValues,
}: {
  defaultNode: {
    renderComponent: any, // TODO: React.ReactElement?
    renderProps: FieldHookProps,
    // formKey: string,
  },
  requestRerender?: () => void,
  defaultValues?: any[],
}) => {
  const getDefaultNodes = () => {
    return (defaultValues && isValidArray(defaultValues)) ? defaultValues.map((val, idx) => {
      return {
        ...defaultNode,
        renderProps: {
          ...defaultNode.renderProps,
          value: val,
          formKey: `${defaultNode.renderProps.formKey}[${idx}]`
        } as FieldHookProps,
      };
    }) : [];
    // If a default node in the beginning is needed, it can be passed in defaultValues.
    // : [{
    //   ...defaultNode,
    //   renderProps: {
    //     ...defaultNode.renderProps,
    //     formKey: `${defaultNode.renderProps.formKey}[0]`,
    //   } as FieldHookProps,
    // }];
  };
  const getDefaultCounter = () => {
    return defaultValues && isValidArray(defaultValues) ? defaultValues.length : 1;
  };
  const coll = useFieldGroup<RefType>({
    defaultNodes: getDefaultNodes(),
  });
  const [counter, setCounter] = React.useState(getDefaultCounter());

  React.useEffect(() => {
    requestRerender && requestRerender();
  }, [coll.nodes, coll.removedNodes]);

  React.useEffect(() => {
    requestRerender && requestRerender();
  }, [coll.refs.some(ref => !(ref.current as any)?.field)]); // TODO: this may not always be 'field'

  const addNode = (formKey?: string, renderProps?: Partial<FieldHookProps>) => {
    coll.setNodes([
      ...coll.nodes,
      {
        ...defaultNode,
        renderProps: {
          ...defaultNode.renderProps,
          disabled: false,
          visible: true,
          formKey: formKey || `${defaultNode.renderProps.formKey}[${counter}]`,
          ...renderProps,
        }        
      },
    ]);
    setCounter(counter + 1);
  };

  const removeNode = (idx) => {
    coll.setRemovedNodes([...coll.removedNodes, idx]);
  };

  return {
    render: coll.render,
    refs: coll.refs,
    nodes: coll.nodes,
    setNodes: coll.setNodes,
    addNode,
    removeNode,
    counter,
    defaultRenderProps: defaultNode.renderProps,
    fieldType: 'multi',
  };
};

export default useMultiField;
